import { useQuery } from '@tanstack/react-query';
import type { PeriodResponse } from '@produzionejb/types';
import { api } from './api-client';

export function useCurrentPeriod() {
  return useQuery({
    queryKey: ['periods', 'current'] as const,
    queryFn: () => api<PeriodResponse>('/api/periods/current'),
    staleTime: 60_000, // 1 min cache: il periodo cambia di rado
  });
}
